import { useLocalObservable } from 'mobx-react-lite';

import { IcClose24Icon, IcDoneIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';
import { IPopoverMenuItem } from '@gem/ui-kit';

import { IGlobalActionsButtonProps } from './GlobalActionsButton.types';

interface IGlobalActionsButtonPresenter {
  menu: IPopoverMenuItem[];
  isPopoverOpened: boolean;
  togglePopover(): void;
  closePopover(): void;
}

export const useGlobalActionsButtonPresenter = (
  props: IGlobalActionsButtonProps
): IGlobalActionsButtonPresenter => {
  const { t } = useTranslation();

  const presenter = useLocalObservable<IGlobalActionsButtonPresenter>(() => ({
    isPopoverOpened: false,

    get menu(): IPopoverMenuItem[] {
      return [
        {
          key: 'approve-all',
          icon: IcDoneIcon,
          title: t('secure_chat_approve_all'),
          onClick: props.onApproveAll,
        },
        {
          key: 'block-all',
          icon: IcClose24Icon,
          title: t('secure_chat_block_all'),
          onClick: props.onBlockAll,
        },
      ];
    },

    togglePopover(): void {
      this.isPopoverOpened = !this.isPopoverOpened;
    },

    closePopover(): void {
      this.isPopoverOpened = false;
    },
  }));

  return presenter;
};
